import * as React from 'react';
import { Avatar, Chip, Tooltip } from '@mui/material';
import xslxSheetIcon from '../../assets/images';
import ImportWizardDialog from './ImportWizardDialog';
import type { ImportAdapter } from './types';

export interface ImportWizardTriggerProps<TEntity> {
    adapter: ImportAdapter<TEntity>;
    currentData: TEntity[];
    onFinished?: () => void;
    chipLabel?: string;
}

/**
 * Drop-in replacement for the old `<DialogUploadFile />` trigger: a chip that opens the
 * guided import wizard. Keeps the same visual language used across the app.
 */
export default function ImportWizardTrigger<TEntity>({ adapter, currentData, onFinished, chipLabel }: ImportWizardTriggerProps<TEntity>) {
    const [open, setOpen] = React.useState(false);
    return (
        <>
            <Tooltip title={chipLabel || `לטעון ${adapter.entityLabelPlural} מאקסל`}>
                <span style={{ display: 'inline-flex' }}>
                    <Chip
                        onClick={() => setOpen(true)}
                        variant="outlined"
                        label={chipLabel || `לטעון ${adapter.entityLabelPlural} מאקסל`}
                        icon={
                            <Avatar
                                variant="square"
                                src={xslxSheetIcon}
                                alt="Excel"
                                sx={{ width: 24, height: 24, mr: 0, ml: 0, p: 0, bgcolor: 'transparent', '& img': { objectFit: 'contain' } }}
                            />
                        }
                        sx={{ ml: 0.5, mr: 0.5, cursor: 'pointer', borderColor: '#008000', color: '#008000', '& .MuiChip-icon': { color: '#008000' } }}
                    />
                </span>
            </Tooltip>
            {open ? <ImportWizardDialog open={open} onClose={() => setOpen(false)} adapter={adapter} currentData={currentData} onFinished={onFinished} /> : null}
        </>
    );
}
